import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import settings from 'react-multi-date-picker/plugins/settings';
import { ChartOption, ChartSerie } from 'interfaces/chart.interface';

interface ChartProps {
  option: ChartOption,
  height?: number
  update?: unknown
  additionnalSeries?: ChartSerie[]
  chartTitle?: string;
  onClick?: ( event: { data: { themeId: unknown } } ) => void;
}

const ChartLoader: React.FC<ChartProps> = ( { option, update, chartTitle } ) => {
  const chartRef = useRef<HTMLDivElement>( null );
  const chartInstanceRef = useRef<echarts.ECharts | null>( null );

  useEffect( () => {
    updateChart();
  }, [ update ] );


  useEffect( () => {
    if ( chartRef.current !== null ) {
      const chart = echarts.getInstanceByDom( chartRef.current );
      chart?.setOption( option );
    }
  }, [ option, settings ] );


  function updateChart() {
    if ( !chartRef.current ) {return;}

    // Dispose uniquement si une instance existe
    if ( chartInstanceRef.current ) {
      chartInstanceRef.current.dispose();
    }

    chartInstanceRef.current = echarts.init( chartRef.current );

    const resizeChart = () => {
      chartInstanceRef.current?.resize();
    };

    window.addEventListener( 'resize', resizeChart );

    return () => {
      window.removeEventListener( 'resize', resizeChart );
      chartInstanceRef.current?.dispose();
      chartInstanceRef.current = null;
    };
  }

  return ( <div className="h-full w-full justify-center text-center">
    <div id={'graph_' + chartTitle} ref={chartRef} className="w-full h-full "></div>
  </div>
  );
};

export default ChartLoader;
